import React, { Component } from 'react';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { withTheme } from 'styled-components';
import { withBreakpoints } from 'react-breakpoints';
import { isEqual, pick } from 'lodash';
import PropTypes from 'prop-types';

import helpers from 'helpers';
import ChartTile from 'components/molecules/charts/ChartTile';
import { DESKTOP_LIMIT, MOBILE_LIMIT } from 'constants/charts';

class TwoAxisBarWithScatterChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const series = [];
        const yAxis = [];
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;
        const yBarTitle = this.props.yBarTitle || helpers.convertToDisplayValue(this.props.yBar);
        const scatterTitle = this.props.scatterTitle || helpers.convertToDisplayValue(this.props.scatter);


        let completeBarData;
        let completeScatterData;
        if (!this.props.categories) {
            completeBarData = helpers.backfill(
                this.props.data.map(r => ({ x: r.date_in_ms, y: r[this.props.yBar] })), this.props.backfillBuckets
            );
            completeScatterData = helpers.backfill(
                this.props.data.map(r => ({ x: r.date_in_ms, y: r[this.props.scatter] })),
                this.props.backfillBuckets
            );
        } else {
            completeBarData = this.props.data.map(r => r[this.props.yBar]);
            completeScatterData = this.props.data.map(r => r[this.props.scatter]);
        }

        if (this.props.showTopOnly) {
            if (this.props.breakpoints[this.props.currentBreakpoint] >= this.props.breakpoints.sm) {
                completeBarData = completeBarData.slice(0, DESKTOP_LIMIT);
                completeScatterData = completeScatterData.slice(0, DESKTOP_LIMIT);
            } else {
                completeBarData = completeBarData.slice(0, MOBILE_LIMIT);
                completeScatterData = completeScatterData.slice(0, MOBILE_LIMIT);
            }
        }

        const barData = {
            ...(this.props.yBarUserOptions || { formatByType: 'number' }),
            name: yBarTitle,
            data: completeBarData,
            type: 'column',
            yAxis: 1,
            color: orderedColors[0]
        };

        const scatterData = {
            ...(this.props.yScatterUserOptions || { formatByType: 'number' }),
            name: scatterTitle,
            data: completeScatterData,
            type: 'spline',
            lineWidth: 0,
            marker: {
                enabled: true,
                radius: 10,
                fillColor: orderedColors[1],
                lineColor: '#ffffff',
                lineWidth: 1,
                states: {
                    hover: {
                        enabled: true
                    }
                }
            },
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            },
            color: orderedColors[1]
        };

        series.push(barData, scatterData);
        const xAxis = helpers.xAxisConfig({
            type: this.props.xAxisType,
            xAxisLabel: this.props.xAxisLabel,
            options: {
                categories: this.props.categories
            }
        });

        const yAxisBar = helpers.yAxisConfig({
            yAxisLabel: yBarTitle,
            options: {
                ...(this.props.yBarOptions || {})
            }
        });

        const yAxisScatter = helpers.yAxisConfig({
            yAxisLabel: scatterTitle,
            options: {
                ...(this.props.yScatterOptions || {}),
                opposite: true
            }
        });

        yAxis.push(yAxisScatter, yAxisBar);

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration,
                }
            },
            column: {
                borderWidth: 0
            }
        };

        const chartTileProps = pick(this.props, ['title', 'subTitle', 'help', 'hideCSVExport']);

        return (
            <ChartTile {...chartTileProps} chartRef={chartRef}>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title,
                            subtitle: this.props.subTitle
                        },
                        chart: {
                            zoomType: 'xy'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        tooltip: {
                            shared: true,
                            ...(this.props.toolTipOptions || {})
                        },
                        legend: {
                            itemStyle: {
                                color: this.props.theme.colors.darkgray
                            }
                        },
                        plotOptions,
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ChartTile>
        );
    }
}

TwoAxisBarWithScatterChart.propTypes = {
    animateDuration: PropTypes.number.isRequired,
    categories: PropTypes.array,
    data: PropTypes.arrayOf(PropTypes.object),
    exportName: PropTypes.string.isRequired,
    scatter: PropTypes.string.isRequired,
    scatterTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    xAxisLabel: PropTypes.string,
    backfillBuckets: PropTypes.array,
    xAxisType: PropTypes.string,
    yBar: PropTypes.string.isRequired,
    yBarOptions: PropTypes.object,
    yBarTitle: PropTypes.string,
    yScatterOptions: PropTypes.object,
    yScatterUserOptions: PropTypes.object,
    help: PropTypes.node
};

export default withTheme(withBreakpoints(TwoAxisBarWithScatterChart));



// WEBPACK FOOTER //
// ./src/components/molecules/charts/TwoAxisBarWithScatterChart.js